import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-warning",
  "use": "icon-ic-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-warning\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#EF8600\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.082 7.57a.5.5 0 0 1 .494-.57h2.848a.5.5 0 0 1 .495.57L13 14h-2l-.918-6.43Z\" fill=\"#fff\" /><path fill=\"#fff\" d=\"M11 15h2v2h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol